import { RealmDomain } from '../app/types/enum';
import { getBrand } from './getBrand';

export const getWindowUrl = () => {
  const origin = window.parent.location.origin.replace(
    RealmDomain.rogers,
    getBrand().domain
  );
  return origin + window.parent.location.pathname;
};
